export const addPhones = (list, selector) => {
  const phonesList = document.querySelector(selector);

  if (phonesList)
    phonesList.appendChild(list)
}